<template>
  <ValidationObserver>

    <div v-bind:id="'skill-' + index">
      <v-card color="grey lighten-5">
        <v-card-text>
          <v-form>
            <v-layout row wrap>
              <v-flex xs12>
                <ValidationProvider name="catégorie de compétences" rules="max:32">
                  <v-text-field
                    slot-scope="{
                                errors,
                                valid
                                }"
                    :error-messages="errors"
                    :success="valid"
                    label="Catégorie de Compétences:"
                    v-model="item.title"
                    v-on:blur="$emit('update-item', item.id, item)"
                  >
                  </v-text-field>
                </ValidationProvider>
              </v-flex>

              <v-flex xs12>
                <OneSkill
                  :skillslist="item.skills"
                  :catid="item.id"
                  :cv_id="cv_id"
                >
                </OneSkill>
              </v-flex>

            </v-layout>
          </v-form>
        </v-card-text>
      </v-card>
    </div>
  </ValidationObserver>
</template>


<script>

import { mixin_basic } from './mixin_basic_vue.js';
import OneSkill from './OneSkill.vue';

export default {
  name: "skillform",
  mixins: [mixin_basic],
  // les autres props sont dans le mixin basic
  props: ['cv_id'],
  components: {
      OneSkill
  },
}

</script>




<style>

</style>
